import React, { useState } from "react";

import SelectBox from "components/atoms/input/SelectBox";

import AbstractModal from "components/page/modal/AbstractModal";
import { ModalContainer, ModalDescText } from "components/page/modal/styled";

import { useNavigatorFolderResourcesCreate, useNavigatorFolders } from "hooks/queries/useNavigator";

function NavigatorFolderEditModal({ exitModal, resources, selectedFolderId = "" }) {
    const folderQuery = useNavigatorFolders();
    const folderResourcesCreate = useNavigatorFolderResourcesCreate();
    const [folderId, setFolderId] = useState(selectedFolderId || "");

    const handleApply = () => {
        folderResourcesCreate.mutate(
            {
                folder_id: folderId || null,
                resources,
            },
            {
                onSuccess: exitModal,
            },
        );
    };

    return (
        <AbstractModal
            modalTitle="폴더 이동"
            width={420}
            exitModal={exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "적용",
                leftOnClick: exitModal,
                rightOnClick: handleApply,
            }}
        >
            <ModalContainer>
                <ModalDescText>선택한 항목을 이동할 폴더를 선택해주세요.</ModalDescText>
                <SelectBox
                    width="100%"
                    height="32px"
                    optionWidth="100%"
                    optionAlign="left"
                    items={[
                        { id: "", name: "폴더 없음" },
                        ...(folderQuery.data || []).map((folder) => ({
                            id: folder.id,
                            name: folder.name,
                        })),
                    ]}
                    value={folderId}
                    onChange={setFolderId}
                />
            </ModalContainer>
        </AbstractModal>
    );
}

export default NavigatorFolderEditModal;
